import { MindmapEngineOptions } from "../types/mindmap-engine-options";

export const DEFAULT_MINDMAP_ENGINE_OPTIONS = {
	initialScale: 0.8,
	minScale: 0.1,
	maxScale: 2,
	clickTimeout: 300,
	preHoverRadius: 100,
	orderIncrement: 10000,
	viewPortAnimationDuration: 250
} satisfies Partial<MindmapEngineOptions>;
